import axios from 'axios'

// 自习室-用户自习室时长账户信息
export function getStudyRoomAccountInfo (datas) {
  const url = '/studyRoom/user/getStudyRoomAccountInfo'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 自习室-获取会员套餐列表
export function getPackageListPage (datas) {
  const url = '/studyRoom/package/getPackageListPage'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 用户答疑记录列表
export function getUserStudyRoomRecordListPage (datas) {
  const url = '/studyRoom/user/getUserStudyRoomRecordListPage'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 查询自习室列表
export function studyRoom (datas) {
  const url = '/studyRoom'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 自习室--自习室状(1未开始，2等待答疑， 3正在答疑)
export function studyRoomSubscribe (datas) {
  const url = '/studyroom/live/studyRoomSubscribe'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 取消自习室--自习室状(1未开始，2等待答疑， 3正在答疑)
export function cancelStudyRoomSubscribe (datas) {
  const url = '/studyroom/live/cancelStudyRoomSubscribe'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取全部自习室基础数据
export function getAllBasicsInfo (datas) {
  const url = '/studyRoom/basics/getAllBasicsInfo'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 自习室定时请求
export function appJoinRoomLog (datas) {
  const url = '/studyroom/live/appJoinRoomLog'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 根据开关类型获取审核开关
export function auditButtonManageByType (datas) {
  const url = '/auditButtonManage/auditButtonManageByType'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 自习室-套餐订单列表
export function getOrderListPage (datas) {
  const url = '/studyRoom/order/getOrderListPage'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 进入答疑直播间
export function entryStudyRoom (datas) {
  const url = '/studyRoom/entryStudyRoom'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/learn/expert.js